import { TabsProps } from 'antd';
import { createPortal } from 'react-dom';

import { OverviewTab } from './Overview';
import { LeaveBalance } from './LeaveBalance';
import { Attendance } from './Attendance';
import { LegalInfo } from './LegalInfo';
import { Assets } from './Assets';

export const getTabsItems = (
  tabContentWrapperClass: string
): TabsProps['items'] => {
  const tabContentWrapperEl = document.getElementsByClassName(
    tabContentWrapperClass
  )[0];

  const items: TabsProps['items'] = [
    {
      label: 'Overview',
      key: 'Overview',
      children: createPortal(<OverviewTab />, tabContentWrapperEl),
    },
    {
      label: 'Leave Balance',
      key: 'Leave Balance',
      children: createPortal(<LeaveBalance />, tabContentWrapperEl),
    },
    {
      label: 'Attendance',
      key: 'Attendance',
      children: createPortal(<Attendance />, tabContentWrapperEl),
    },
    {
      label: 'Assets',
      key: 'Assets',
      children: createPortal(<Assets />, tabContentWrapperEl),
    },
    // TODO: Uncomment when will ready
    // {
    //   label: 'Education',
    //   key: 'Education',
    //   children: createPortal('Education tab content', tabContentWrapperEl),
    // },
    // {
    //   label: 'Experience',
    //   key: 'Experience',
    //   children: createPortal('Experience tab content', tabContentWrapperEl),
    // },
    {
      label: 'Legal Info',
      key: 'Legal Info',
      children: createPortal(<LegalInfo />, tabContentWrapperEl),
    },
    {
      label: 'Official Documents',
      key: 'Official Documents',
      children: createPortal(
        'Legal Info & Official Documents tab content',
        tabContentWrapperEl
      ),
      disabled: true,
    },
  ];

  return items;
};
